import { Injectable } from '@angular/core';
import Pusher from 'pusher-js';

@Injectable({
  providedIn: 'root'
})
export class PusherV2Service {
  private pusher: Pusher;
  private channels: { [key: string]: any } = {};

  constructor() {
    this.pusher = new Pusher('eb5150b9b1988b68581b', {
      cluster: 'mt1',
    });
  }

  /**
   * S'abonne à un channel spécifique et écoute un événement donné
   */
  listen(channelName: string, eventName: string, callback: (data: any) => void): void {
    if (!this.channels[channelName]) {
      this.channels[channelName] = this.pusher.subscribe(channelName);
    }

    this.channels[channelName].bind(eventName, callback);
  }

  /**
   * Se désabonne d'un channel spécifique
   */
  unsubscribe(channelName: string): void {
    if (this.channels[channelName]) {
      this.pusher.unsubscribe(channelName);
      delete this.channels[channelName];
    }
  }

  /**
   * Déconnecte tous les abonnements
   */
  disconnect(): void {
    for (const channelName in this.channels) {
      this.pusher.unsubscribe(channelName);
    }
    this.channels = {};
    this.pusher.disconnect();
  }
}
